module.exports = __webpack_public_path__ + "img/img_remote_system04.1c75d6d9.jpg";